import React from 'react'
import { usePipeline } from '@morningtrain/react-helpers'
import useOnBeforeThemeChange from './hooks/use-on-before-theme-change'

export default function TriggerPipelineOnBeforeThemeChange () {
  const pipeline = usePipeline()

  useOnBeforeThemeChange(() => {
    return pipeline.trigger({ })
  })

  return null
}
